<template>
  <section>

    <Airplane />
    <Cloud />
    <header>
      <button @click="$router.go(-1)"></button>
      <h2 v-html="'Let your code fly'"></h2>
      <p v-if="$route.params.service">You have choosen {{$route.params.service.name}} service</p>
    </header>
			<form-config-provider-front
        v-if="currentRoute === $i18n.t('services.front.name')" />
			<form-config-provider-ia
        v-else-if="currentRoute ===  $i18n.t('services.ia.name')" />
			<form-config-provider-website
        v-else-if="currentRoute ===  'Project Management'" />
			<form-config-provider-psd2html
        v-else-if="currentRoute === 'PSD to HTML'" />
			<form-config-provider-animations
        v-else-if="currentRoute ===  'Web Animations'" />
      <form-config-provider-simple 
        v-else/>

  </section>
</template>

<script>

import FormConfigProviderWebsite from "../FormConfigProviderWebsite"
import FormConfigProviderIa from "../FormConfigProviderIa"
import FormConfigProviderFront from "../FormConfigProviderFront"
import FormConfigProviderPsd2html from "../FormConfigProviderPsd2html"
import FormConfigProviderAnimations from "../FormConfigProviderAnimations"
import FormConfigProviderSimple from "../FormConfigProviderSimple"

import Airplane from '@/components/origami/Airplane'
import Cloud from '@/components/origami/Cloud'

export default {
  name: 'step-2',
  components: {
    FormConfigProviderWebsite,
    FormConfigProviderIa,
    FormConfigProviderFront,
    FormConfigProviderSimple,
    FormConfigProviderAnimations,
    FormConfigProviderPsd2html,
    Airplane,
    Cloud
  },
  mounted () {
    !this.$route.params.service && this.$router.push({name: 'contacts'})
  },
  computed: {
    currentRoute () {
      return this.$route.params.service && this.$route.params.service.name
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../styles/_mixins.scss';

section {
  position: relative;
  @include grid-padding;
  @include grid-container;
  text-align: center;
  padding-bottom: 25vh;
  height: 100vh;
  overflow-y: scroll;
  

  @include respond-to(desktop) {
    // max-height: 75vh;
    @include grid(12);
    text-align: left;
  }
  header {
    padding-top: 1vmin; 
    padding-bottom: $small-vmin; 
    grid-column: 2 / span 7;

    @include respond-to(tablet) {
      padding-top: 5vmin; 
    }

    > button {
      position: relative;
      background: rgba(250,250,250,0.5);
      color: #409DAE;
      width: 2rem;
      height: 2rem;

      &:before,
      &:after {
        content: '';
        position: absolute;
        width: 3px;
        height: 50%;
        background: map-get($colors--accents, 'fourth');
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }

      &:before {
        transform: translate(-50%, -50%) rotate(-45deg);
      }

      &:after {
        transform: translate(-50%, -50%) rotate(45deg);
      }

    }

    p,h2 {
      color: map-get($colors--grays, '2');
    }
  
    h2 {
      text-transform: capitalize;
      font-size: 6.5vmin;
      line-height: 1;

      @include respond-to(tablet) {
        margin-bottom: $small-vmin;
      }
    }

  }

  form {
    grid-column: 2 / span 6;
  }


}
</style>
